import {GolferDetail} from "../../helpers/golferFields";
import firebase from "firebase/compat";
import {IOrderInfo} from "../IOrderInfo";

export interface IFinalOrder {
    golferDetails?: GolferDetail[],
    phone: string,
    email: string,
    name?: string,
    basketPrice: number,
    tip: number,
    courseId: string,
    section?: string,
    onCourse: boolean,
    hole?: number,
    courseReference?: firebase.firestore.DocumentReference,
    state: string,
    paymentMethod: number,
    paid: boolean,
    refCode?: string,
    createdDate: number,
    updatedDate?: number,
    isDeleted: boolean
}

export function mapOrderToFinalOrder(order: IOrderInfo): IFinalOrder
{
    const {basketItems, ...finalOrder} = order;
    return finalOrder;
}
